import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface ComplianceGaugeProps {
  compliance: number; // 0..1
  upToDate: number;
  total: number;
}

export function ComplianceGauge({ compliance, upToDate, total }: ComplianceGaugeProps) {
  const pct = Math.round(compliance * 100);
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          Update compliance
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="flex items-baseline gap-2">
          <span className="text-3xl font-semibold tabular-nums">{pct}%</span>
          <span className="text-xs text-muted-foreground">
            {upToDate} of {total} devices up to date
          </span>
        </div>
        <Progress value={pct} aria-label="Update compliance" />
      </CardContent>
    </Card>
  );
}

export default ComplianceGauge;
